export default class LocationAdapter {
  static global() {
    return window.location;
  }

  static reload() {
    this.global().reload(...arguments);
  }

  static href(url) {
    if (url === undefined) {
      return this.global().href;
    }
    this.global().href = url;
  }

  static search() {
    const raw = this.global().search;
    const queryParams = raw.replace('?', '').split('&');

    var obj = {};
    queryParams.forEach((item) => {
      if(!item) return;
      const pair = item.split('=');
      obj[pair[0]] = pair[1];
    });
    return obj;
  }
}
